// Decodes the payload of a JWT. The payload is base64url-encoded UTF-8 JSON: every '-' and '_' has to
// be mapped back (not just the first), the stripped '=' padding restored, and the bytes decoded as UTF-8 —
// atob alone yields Latin-1, which garbles or breaks on non-ASCII claims such as a user named "Roß".
export const decodeJwtPayload = <T = unknown>(token: string): T => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(Math.ceil(base64Url.length / 4) * 4, '=');
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
};
